<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-delete-icon perm="configuration.delete" @invoke-method="deleteAllSessions()"></bc-btn-delete-icon>
                            <bc-btn-refresh @invoke-method="dbGetSessions()" permanent></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3 mt-3">
                                        <bc-autocomplete
                                            v-model="filter.user_id"
                                            :label="$t('lang.person')"
                                            :items="people"
                                            item-value="user_id"
                                            item-text="combined_name"
                                            single-line
                                            prepend-icon="person"
                                            clearable
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <!-- <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobileList"
                            ></bc-btn-mobile-nav> -->
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="sessions" hide-actions :no-data-text="$t('lang.no_data_available')">
                        <template slot="items" slot-scope="props">
                            <td class="clickable" @mouseup.left="(viewCurrentSession = true), (activeUser = props.item)">{{ props.item.user_id }}</td>
                            <td class="clickable" @mouseup.left="(viewCurrentSession = true), (activeUser = props.item)">{{ props.item.combined_name }}</td>
                            <td class="clickable" @mouseup.left="(viewCurrentSession = true), (activeUser = props.item)">{{ props.item.username }}</td>
                            <td class="clickable" @mouseup.left="(viewCurrentSession = true), (activeUser = props.item)">{{ props.item.ip_address }}</td>
                            <td class="clickable" @mouseup.left="(viewCurrentSession = true), (activeUser = props.item)">{{ props.item.date_expires }}</td>
                            <td v-if="hasPerm('configuration.delete')">
                                <v-layout justify-center pa-0 ma-0>
                                    <div>
                                        <v-btn color="error" small @mouseup.left="deleteSession(props.item.token_id)">{{ $t("lang.delete") }}</v-btn>
                                    </div>
                                </v-layout>
                            </td>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="settings_active_sessions"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="viewCurrentSession" max-width="600">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ activeUser.first_name + $t("lang.user_session") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="viewCurrentSession"
                            :dialog-status="viewCurrentSession"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text class="prevent-click">
                        <v-form v-model="validSession">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="activeUser.first_name" :label="$t('lang.first_name')" readonly maxLength="35"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="activeUser.last_name" :label="$t('lang.last_name')" readonly maxLength="35"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="activeUser.username" :label="$t('lang.username')" readonly maxLength="100"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="activeUser.user_id" :label="$t('lang.user_id')" readonly maxLength="15"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="activeUser.ip_address" :label="$t('lang.ip_address')" readonly maxLength="45"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="activeUser.remember_me" :label="$t('lang.remember_me')" readonly maxLength="40"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="activeUser.date_created" :label="$t('lang.date_created')" readonly></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field v-model="activeUser.date_modified" :label="$t('lang.date_modified')" readonly></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="viewCurrentSession = false">{{ $t("lang.cancel") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
        </v-container>

        <delete-confirmation-dialog
            ref="deleteDialog"
            :message="$t('lang.active_session_delete_confirm')"
            :heading="$t('lang.delete_active_session')"
            @onConfirm="onDeleteConfirm"
        ></delete-confirmation-dialog>
        <delete-confirmation-dialog
            ref="deleteAllDialog"
            :message="$t('lang.active_sessions_delete_confirm')"
            :heading="$t('lang.delete_active_sessions')"
            @onConfirm="onDeleteAllConfirm"
        ></delete-confirmation-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { store } from "Store/store";

import BcBtnDeleteIcon from "Components/Buttons/BcBtnDeleteIcon";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.user_id"), sortable: false },
                { text: this.$t("lang.client_name"), sortable: false },
                { text: this.$t("lang.username"), sortable: false },
                { text: this.$t("lang.ip_address"), sortable: false },
                { text: this.$t("lang.expires"), sortable: false },
                { text: this.$t("lang.select_a_session"), sortable: false, align: "center", width: "212" },
            ],
            update: {
                status: null,
            },
            token_id: null,
            activeUser: {},
            mobileList: [{ title: this.$t("lang.refresh"), action: "dbGetSessions" }],
            dbGetSessions: _.debounce(this.getSessions, 1500, { maxWait: 1500, leading: true, trailing: false }),
            filter: {
                page_size: 0,
                page_num: 1,
                user_id: "",
            },
            totalSessions: 0,
            viewCurrentSession: false,
            validSession: false,
            sessions: [],
            page: {},
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchActiveSessions", {
                url: "access_tokens",
                method: "get",
                stateProperty: "sessions",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.sessions) {
                    next((vm) => {
                        if (!vm.hasPerm("configuration.delete")) vm.headers.pop();
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.sessions = data.sessions;
                        vm.page = data.page;
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchActiveSessions", {
                url: "access_tokens",
                method: "get",
                stateProperty: "sessions",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.sessions) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.sessions = data.sessions;
                    this.page = data.page;
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            session: (state) => state.sessions.sessions,
            default_filter: (state) => state.active_sessions.sessions_filter,
            people: (state) => state.people.person_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        ...mapActions(["fetchPeople"]),
        getSessions(status = true) {
            if (status) this.startLoader();
            this.$store
                .dispatch("fetchActiveSessions", {
                    url: "access_tokens",
                    method: "get",
                    stateProperty: "sessions",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.sessions) {
                        this.sessions = data.sessions;
                        this.page = data.page;
                    } else {
                        this.$router.push({ name: "dashboard" });
                    }
                })
                .finally(() => {
                    this.$store.commit("toggleModalLoader", false);
                    this.$refs.deleteDialog.close();
                    this.$refs.deleteAllDialog.close();
                    this.finishLoader(true);
                });
        },
        deleteSession(id) {
            if (id) {
                this.token_id = id;
                this.$refs.deleteDialog.openDialog();
            }
        },
        onDeleteConfirm() {
            this.$store.commit("toggleModalLoader", true);

            this.$store
                .dispatch("fetchActiveSessions", {
                    pk: "token_id",
                    id: this.token_id,
                    url: "access_tokens/" + this.token_id,
                    method: "delete",
                    stateProperty: "sessions",
                    mutate: true,
                })
                .then((data) => {
                    if (data && data.code == "200") {
                        this.$refs.deleteDialog.close();
                        this.$store.commit("toggleModalLoader", false);
                    } else {
                        this.$store.commit("toggleModalLoader", false);
                    }
                });
        },
        deleteAllSessions() {
            this.$refs.deleteAllDialog.openDialog();
        },
        onDeleteAllConfirm() {
            this.$store.commit("toggleModalLoader", true);

            this.$store
                .dispatch("fetchActiveSessions", {
                    pk: "token_id",
                    id: this.token_id,
                    url: `access_tokens/all${this.filter.user_id ? "/" + this.filter.user_id : ""}`,
                    method: "delete",
                    stateProperty: "sessions",
                    mutate: true,
                })
                .then((data) => {
                    if (data && data.code == "200") {
                        this.$refs.deleteAllDialog.close();
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        refresh() {
            if (this.people.length == 0) {
                this.fetchPeople({ body: { options: 1 } });
            }
        },
    },
    mounted() {
        this.refresh();
    },
    components: {
        BcBtnDeleteIcon,
    },
};
</script>
